import React, { memo, useEffect, useRef, useState } from 'react';
import useIsBody from '@wconcept/wconcept-ui-renewal/hooks/useIsBody';
import { AccordionPanelWrap } from './AccordionPanelStyles';

interface IProps {
  children?: React.ReactNode;
  id?: string;
  label?: React.ReactNode;
  className?: string;
  value?: string;
  ariaLabelledby?: string;
  hidden?: boolean;
  extra?: React.ReactNode;
  onClick?: () => void;
}

const AccordionPanel = ({
  id,
  className,
  children,
  ariaLabelledby,
  hidden,
  label = '',
  value = '',
  onClick,
}: IProps) => {
  const panelRef = useRef<HTMLDivElement>(null);
  const element = panelRef?.current;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [_height, setHeight] = useState<number | undefined>(
    element?.scrollHeight
  );

  const { isBody } = useIsBody();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const element = panelRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setHeight(entry.target.scrollHeight);
          }
        });
      },
      { threshold: 0.1 } // 요소가 화면에 10% 이상 보일 때 감지합니다.
    );

    observer.observe(element);

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // if (!hidden) {
    //   const element = panelRef.current;
    //   if (element) setHeight(element.scrollHeight);
    // } else {
    //   setHeight(0);
    // }

    /* if (hidden) {
      setHeight(0);
    } else {
      if (element) setHeight(element?.scrollHeight);
    } */

    if (isBody) {
      if (element) setHeight(element?.scrollHeight);
    }
  }, [hidden, element, isBody]);

  const param: any = {
    id: id || undefined,
    role: 'region',
    className,
    'aria-labelledby': ariaLabelledby,
    hidden,
    ref: panelRef,
    height: _height,
  };

  return (
    <AccordionPanelWrap {...param} onClick={onClick}>
      {children}
    </AccordionPanelWrap>
  );
};

export default memo(AccordionPanel);
